<div class="row">
  <h6 style="margin-left: 25px">
    <span style="color: #f49602">&#9679;</span>
    &nbsp; Please add the open mold specific data
  </h6>

  <div class="col-md-12 col-xl-5 m-3">
    <div class="box">
      <p>Injection parameters</p>

      <div class="row">
        <div class="col-6">
          <usimweb-form-input
            placeholder="Injection time [s]"
            [value]="openMold.injectionTime"
            [type]="inputType.FLOAT_NUMBER"
            [readonly]="true"
          ></usimweb-form-input>
        </div>

        <div class="col-6">
          <usimweb-form-input
            placeholder="Injection rate [kg/s]"
            [value]="openMold.injectionRate"
            [type]="inputType.FLOAT_NUMBER"
            [readonly]="true"
          ></usimweb-form-input>
        </div>
      </div>
    </div>

    <div class="box">
      <p>Mold closing options</p>

      <div class="row">
        <div class="col-3">
          <usimweb-form-input
            placeholder="Start closing [s]"
            [value]="openMold.moldClosingTime | number : '.2-2'"
            [type]="inputType.FLOAT_NUMBER"
            [readonly]="true"
          ></usimweb-form-input>
        </div>

        <div class="col-1">
          <usimweb-icon [icon]="'drag_handle'" style="margin-top: 20px" class="icon"></usimweb-icon>
        </div>

        <div class="col-3">
          <usimweb-form-input
            placeholder="Offset [s]"
            [type]="inputType.FLOAT_NUMBER"
            [value]="closing_time_offset"
            (selectionChange)="calcMoldClosingTime($event)"
            [required]="true"
          ></usimweb-form-input>
        </div>

        <div class="col-1">
          <usimweb-icon [icon]="'add'" style="margin-top: 20px" class="icon"></usimweb-icon>
        </div>

        <div class="col-3">
          <usimweb-form-input
            placeholder="Start [s]"
            [type]="inputType.FLOAT_NUMBER"
            [value]="openMold.start"
            (selectionChange)="startValueChanged($event)"
            (selectionChange)="blur()"
            [required]="true"
          ></usimweb-form-input>
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          <usimweb-form-input
            placeholder="End closing [s]"
            [value]="openMold.moldClosingTimeDuration | number : '.2-2'"
            [type]="inputType.FLOAT_NUMBER"
            [readonly]="true"
          ></usimweb-form-input>
        </div>

        <div class="col-1">
          <usimweb-icon [icon]="'drag_handle'" style="margin-top: 20px" class="icon"></usimweb-icon>
        </div>

        <div class="col-3">
          <usimweb-form-input
            placeholder="Mold closing time [s]"
            [type]="inputType.FLOAT_NUMBER"
            [value]="openMold.moldClosingTime | number : '.2-2'"
            [readonly]="true"
          ></usimweb-form-input>
        </div>

        <div class="col-1">
          <usimweb-icon [icon]="'add'" style="margin-top: 20px" class="icon"></usimweb-icon>
        </div>

        <div class="col-3">
          <usimweb-form-input
            placeholder="Duration [s]"
            [type]="inputType.FLOAT_NUMBER"
            [value]="openMold.duration"
            (selectionChange)="durationValueChanged($event)"
            (selectionChange)="blur()"
            [required]="true"
          ></usimweb-form-input>
        </div>
      </div>
    </div>

    <div class="box">
      <p>Nozzle parameters</p>

      <div *ngIf="openMold.nozzleDiameter" class="row">
        <div class="col-6">
          <usimweb-form-input
            placeholder="Nozzle velocity [m/s]"
            [value]="openMold.nozzleVelocity"
            [type]="inputType.FLOAT_NUMBER"
            [readonly]="true"
          ></usimweb-form-input>
        </div>

        <div class="col-6">
          <usimweb-form-input
            placeholder="Nozzle diameter [mm]"
            [type]="inputType.FLOAT_NUMBER"
            [value]="openMold.nozzleDiameter"
            (selectionChange)="nozzleDiameterChanged($event)"
            (selectionChange)="blur()"
            [required]="true"
          ></usimweb-form-input>
        </div>
      </div>

      <div *ngIf="!openMold.nozzleDiameter" class="row">
        <div class="col-12">
          <usimweb-form-input
            placeholder="Nozzle diameter [mm]"
            [type]="inputType.FLOAT_NUMBER"
            [value]="openMold.nozzleDiameter"
            (selectionChange)="nozzleDiameterChanged($event)"
            (selectionChange)="blur()"
            [required]="true"
          ></usimweb-form-input>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-12 col-xl-6 m-3" style="position: relative; height: 90%">
    <div class="box">
      <div style="display: inline-block">
        <usimweb-checkbox [label]="'Toggle vectors'" (onChange)="toggleVector($event)"></usimweb-checkbox>
      </div>

      <div style="display: inline-block; margin-left: 15px">
        <div (click)="nozzleInput()" style="display: inline-block">
          <usimweb-form-input
            [value]="nozzleOffset"
            placeholder="Nozzle offset"
            (selectionChange)="nozzleOffsetChanged($event)"
            [required]="true"
          ></usimweb-form-input>
        </div>

        <div style="display: inline-block">
          <usimweb-button-icon [icon]="'done'" fontColor="white" *ngIf="isOffsetClicked"></usimweb-button-icon>
        </div>
      </div>

      <!-- <div>
        <button
          style="position: absolute; top: 0px; right: 90px"
          class="btn-round-orange"
          type="button"
          (click)="openPointSelectionInfo()"
          usimweb-icon-button>
          <usimweb-icon
            matBadge="{{ pointAmount }}"
            matBadgeSize="medium"
            matBadgeColor="warn"
            tooltip="Show points table"
            >search</usimweb-icon
          >
        </button>
      </div> -->

      <div>
        <usimweb-button-icon
          [icon]="'delete'"
          fontColor="white"
          color="red"
          style="position: absolute; top: 0px; right: 30px"
          (btnClick)="deleteAllPoints()"
          tooltip="Delete all points"
        ></usimweb-button-icon>
      </div>

      <div>
        <usimweb-icon
          [icon]="'info'"
          style="color: #f49602; position: absolute; top: 120px; right: 40px; font-size: 22px"
          (onClick)="openInfoDialog()"
          [toolTip]="'For more info how to use the viewer click here...'"
        >
          info
        </usimweb-icon>
      </div>

      <ceetron-viewer #viewer *ngIf="loadViewer" style="display: inline-block"></ceetron-viewer>
    </div>
  </div>
</div>
